import { useState } from "react";

import { useTranslation } from "react-i18next";

import { PasswordIcon } from "@dotnet/telematics-design-system";

import { BUTTON_COLORS } from "components/DesignComponents/Button/types/enums";

import ContentFrameGroup from "../../ContentFrameGroup";
import ChangePasswordModal from "./ChangePasswordModal";

const ChangePassword = () => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    const openDialog = () => setIsOpen(true);
    const closeDialog = () => setIsOpen(false);

    return (
        <>
            <ContentFrameGroup
                title={t("Security##password##settings##title")}
                description={t("Security##password##settings##description")}
                buttonText={t("Button##change")}
                buttonColor={BUTTON_COLORS.Secondary}
                icon={<PasswordIcon />}
                onButtonClick={openDialog}
            />

            <ChangePasswordModal isOpen={isOpen} close={closeDialog} />
        </>
    );
};

export default ChangePassword;
